import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import "bulma/css/bulma.css";
import 'bulma-o-steps/bulma-steps.css';
import axios from "axios";
import 'react-bulma-dropdown/dist/main.css';
import 'bulma-o-steps/bulma-steps.css'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./styles.css";

axios.defaults.withCredentials = true;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
        <App />
    </Provider>
  </React.StrictMode>
);

